export default __webpack_public_path__ + "static/fp-nextImage-893c6fa52bf413a7f92232ef8eeef2c5.jpg";